<template>
  <div>
    <v-container fluid class="pa-0 position-relative">
        <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value.visitName || 'گالری صوتی'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>

      <v-card
        dark
        outlined
        class="px-3 rounded-xl view-holder mx-auto"
        max-width="396"
      >
        <v-card
          outlined
          width="30%"
          height="6px"
          class="mx-auto mt-2 mb-5 rounded-pill"
          light
        />

        <div id="div1">
          <div id="div2" />

          <v-card
            light
            outlined
            width="9"
            height="9"
            class="rounded-pill"
            style="margin-top: 6px"
          />
          <v-card
            light
            outlined
            width="14"
            height="14"
            class="rounded-pill ms-3"
            style="margin-top: 3px"
          />
        </div>
        <component
          :is="components[value.photo.transition || 'scale']"
          mode="out-in"
          origin="center"
        >
          <div
            v-if="showWelcome && value.photo.hasWelcome"
            class="col-md-11 bg-white mx-auto d-flex"
            style="min-height: 75vh"
            key="loading"
          >
            <div class="col m-auto" v-if="value.photo.welcome === ''">
              <atom-spinner
                :animation-duration="1000"
                :size="80"
                class="mx-auto justify-content-center"
                color="#ff1d5e"
              />
            </div>
            <div class="m-auto" v-if="value.photo.welcome !== ''">
              <img
                class="bg-white img-fluid rounded-circle mx-auto my-auto"
                width="100"
                :src="value.photo.welcome"
                alt=""
              />
            </div>
          </div>
          <v-card
            light
            flat
            class="overflow-y-auto rounded-lg view-wrapper px-0"
            height="70vh"
            max-height="660"
            :style="{
              background: value.pallete.headColor,
              color: value.pallete.textColor,
            }"
          >
            <div class="col-md-12 text-center mx-auto mt-2 mb-0 pb-0">
              <profile-photos
                :value="value.photo"
                :size="'100px'"
                :style="{
                  background: value.pallete.headColor,
                  color: value.pallete.textColor,
                }"
              ></profile-photos>
              <p class="mt-3">{{ value.organizationName }}</p>
              <p class="mt-0 pt-0">{{ value.subtitle }}</p>
            </div>

            <template v-if="value?.audiosGallery?.audios?.length > 0">
              <!-- <video-card-view
                v-if="
                  value.VideoGallery.secondPosition && item.images.length > 0
                "
                :description="value.VideoGallery"
                :style="{
                  background: value.pallete.bodyColor,
                  color: value.pallete.textColor,
                }"
                :data="item"
              /> -->
              <voice-card-view
                v-if="value?.audiosGallery?.audios?.length > 0"
                :style="{
                  background: value.pallete.bodyColor,
                  color: value.pallete.textColor,
                }"
                :data="value?.audiosGallery?.audios"
                :type="value?.audiosGallery?.audioType"
              />
            </template>

            <!-- <b-gallery-view
              :style="{
                background: value.pallete.bodyColor,
                color: value.pallete.textColor,
              }"
              v-if="
                !value.VideoGallery.slider && !value.VideoGallery.secondPosition
              "
              :is-img="false"
              :title="value.VideoGallery.title"
              :is-grid="false"
              :description="value.VideoGallery.description"
              v-model="value.video_gallery"
            /> -->

            <show-info
              class="mt-0"
              v-model="value"
              :style="{
                background: value.pallete.headColor,
                color: value.pallete.textColor,
              }"
            />
          </v-card>
        </component>
        <!-- <floating-btn
          v-model="value.socialMedia"
          class="position-absolute"
          style="bottom: 80px; right: 35px"
        /> -->
        <v-card
          light
          outlined
          width="40"
          height="40"
          class="rounded-pill mx-auto my-2"
        />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import ShowInfo from "@/view/pages/otherQrTypes/photoGallery/components/showInfo";
import BGalleryView from "@/view/pages/businessPage/components/view/bGalleryView";
import FloatingBtn from "@/view/pages/otherQrTypes/photoGallery/components/floatingBtn";
import ViewPage from "@/view/pages/businessPage/components/view/viewPage";
import GallerySlider from "@/view/pages/businessPage/components/view/gallerySlider";
import {
  VFadeTransition,
  VScaleTransition,
  VSlideXTransition,
  VSlideYTransition,
} from "vuetify/lib/components";
import { Bus } from "@/main";
// import VideoCardView from "@/view/pages/otherQrTypes/videoGallery/components/videoCardView";
import ProfilePhotos from "@/view/components/repeatitive/profilePhotos";
import VoiceCardView from "./voiceCardView.vue";
import UniversalQrModal from "../../../components/UniversalQrModal.vue";


export default {
  name: "voiceGalleryMobile",
  components: {
    ProfilePhotos,
    GallerySlider,
    ViewPage,
    FloatingBtn,
    BGalleryView,
    ShowInfo,
    VoiceCardView,
    UniversalQrModal
  },

  props: {
    value: Object,
    qrSvgDataUrl: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      showQrDialog: false,
      showWelcome: false,
      components: {
        scale: VScaleTransition,
        slideX: VSlideXTransition,
        slideY: VSlideYTransition,
        fade: VFadeTransition,
      },
    };
  },
  computed: {
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },
},
  mounted() {
    Bus.$on("showMe", (value) => {
      if (this.value?.photo?.hasWelcome) {
        this.showWelcome = true;
        setTimeout(() => {
          this.showWelcome = false;
        }, 3000);
      }
    });
  },
};
</script>

<style scoped>
.view-holder {
  background-color: #979797;
}

.view-wrapper::-webkit-scrollbar {
  display: none;
}

#div1 {
  display: flex;
  justify-content: center;
  top: 35px;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  height: 28px;
  width: 40%;
  margin: -1px auto 8px;
  perspective: 100px;
  z-index: 2;
}

#div2 {
  position: absolute;
  height: 100%;
  width: 100%;
  top: -3px;
  /*border: thin solid rgba(0, 0, 0, .2);*/
  border-radius: 0 0 16px 16px;
  transform-style: preserve-3d;
  transform: rotateX(-46deg);
  z-index: 0;
  background-color: #979797;
}
.qr-floating-btn {
  position: absolute;
  top: 40px;
  left: 17px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
